export default __webpack_public_path__ + "static/media/montreal.039bd8be.jpg";